module.exports = __webpack_public_path__ + "img/typcomp.59036636.png";